import { render, staticRenderFns } from "./TaskDocumentModal.vue?vue&type=template&id=2853e718&"
import script from "./TaskDocumentModal.vue?vue&type=script&lang=js&"
export * from "./TaskDocumentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2853e718')) {
      api.createRecord('2853e718', component.options)
    } else {
      api.reload('2853e718', component.options)
    }
    module.hot.accept("./TaskDocumentModal.vue?vue&type=template&id=2853e718&", function () {
      api.rerender('2853e718', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Modals/TaskDocumentModal.vue"
export default component.exports